import React from 'react';
import './WhatsAppFloat.css';

const WhatsAppFloat = () => (
  <a
    href="https://wa.me/918873056889"
    className="whatsapp-float"
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Chat on WhatsApp"
  >
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="18" cy="18" r="18" fill="#25D366"/>
      <path d="M27.5 18c0-5.24-4.26-9.5-9.5-9.5S8.5 12.76 8.5 18c0 1.67.44 3.29 1.28 4.71L8 28l5.41-1.76A9.46 9.46 0 0 0 18 27.5c5.24 0 9.5-4.26 9.5-9.5zm-9.5 8.13c-1.5 0-2.97-.4-4.24-1.16l-.3-.18-3.21 1.04 1.05-3.13-.19-.32A8.13 8.13 0 1 1 18 26.13zm4.44-5.36c-.24-.12-1.41-.7-1.63-.78-.22-.08-.38-.12-.54.12-.16.24-.62.78-.76.94-.14.16-.28.18-.52.06-.24-.12-1.01-.37-1.92-1.18-.71-.63-1.19-1.41-1.33-1.65-.14-.24-.01-.37.11-.49.12-.12.27-.32.4-.48.13-.16.17-.28.25-.47.08-.19.04-.35-.02-.48-.06-.12-.54-1.3-.74-1.78-.2-.48-.4-.41-.54-.42-.14-.01-.3-.01-.46-.01-.16 0-.42.06-.64.28-.22.22-.84.82-.84 2 0 1.18.86 2.32.98 2.48.12.16 1.7 2.7 4.13 3.67.58.2 1.03.32 1.38.41.58.15 1.1.13 1.51.08.46-.07 1.41-.58 1.61-1.14.2-.56.2-1.04.14-1.14-.06-.1-.22-.16-.46-.28z" fill="#fff"/>
    </svg>
  </a>
);

export default WhatsAppFloat; 